const styles = {
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    width: '100vw',
    height: '100vh'
  },
  content: {
    position: 'relative',
    margin: '0 auto 20rem auto',
    zIndex: 10,
    background: '#ffffff',
    width: '50rem',
    maxWidth: '100vw',
    height: '75vh',
    padding: '3rem 3rem 30rem 3rem',
    color: 'black',
    overflowY: 'scroll',
    overflowX: 'hidden'
  },
  imgLogo: {
    maxWidth: '100%',
    position: 'relative',
    top: '-25px'
  },
  imgInline: { maxWidth: '100%' },
  imgFurryTrash: {
    position: 'absolute',
    right: 10,
    top: '11rem',
    mixBlendMode: 'multiply',
    maxWidth: '30vw'
  },
  animatedLogo: {
    height: '50vh',
    mixBlendMode: 'exclusion',
    zIndex: 5,
    animation: 'zoom-in-zoom-out 300s ease infinite',
    animationDirection: 'alternate-reverse',
    filter: 'grayscale(100%)'
  },
  animatedBackground: {
    mixBlendMode: 'multiply',
    zIndex: 5,
    width: '200vw',
    height: '200vh',
    top: -100,
    left: -100,
    position: 'fixed',
    animation: 'zoom-in-zoom-out 50s ease infinite',
    animationDirection: 'alternate-reverse'
  },
  staticBackground: {
    mixBlendMode: 'overlay',
    zIndex: 5,
    width: '100vw',
    height: '100vh',
    top: 0,
    left: 0,
    position: 'fixed'
  },
  textArea: {
    position: 'absolute',
    width: '100vw',
    height: '200vh',
    fontSize: '50rem',
    left: 0,
    top: 0,
    mixBlendMode: 'multiply',
    border: 0,
    opacity: 0.5,
    background: 'transparent',
    transform: 'rotate(2deg) translateY(-50px)',
    maxWidth: '100vw',
    color: 'white'
  },
  staticLogoWrapper: {
    position: 'absolute',
    top: 50,
    left: 0,
    width: '100vw',
    mixBlendMode: 'multiply',
    display: 'flex'
  },
  staticLogo: {
    margin: 'auto',
    maxWidth: '100vw',
    width: '500px',
    mixBlendMode: 'multiply'
  },
  bullet: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  bulletImage: {
    marginRight: '1rem'
  },
  caption: {
    marginTop: '-2.5rem',
    marginLeft: '.5rem',
    color: 'white',
    opacity: '0.5',
    textTransform: 'uppercase',
    fontWeight: 900,
    fontSize: '.7rem',
    position: 'absolute'
  },
  downloadButton: {
    color: 'white',
    fontWeight: '900',
    background: 'blue',
    width: '20rem',
    borderRadius: '0.3rem',
    height: '5rem',
    margin: 'auto',
    display: 'flex',
    alignItems: 'center'
  }
};
export default styles;
